function formatKey(key) {
    const [start, ...rest] = key.split('-');
    return `${start}${!rest ? '' : rest.map((k) => `${k[0].toUpperCase()}${k.slice(1)}`).join('')}`;
}
function convertStyleStringToStyleObject(styleString) {
    return styleString.split(';').reduce((output, item) => {
        const [key, value] = item.split(':');
        if (key && value) {
            output[formatKey(key)] = value;
        }
        return output;
    }, {});
}
const getCustomStyles = (item) => {
    if (!item.customStyle?.length) {
        return {};
    }
    return convertStyleStringToStyleObject(item.customStyle);
};
const getCustomIconStyles = (item) => {
    if (!item.customStyleIcon?.length) {
        return {};
    }
    return convertStyleStringToStyleObject(item.customStyleIcon);
};

export { getCustomIconStyles, getCustomStyles };
//# sourceMappingURL=styles.js.map
